export const FORM_PROJECT = 'FORM_PROJECT'
export const GET_PROJECT = 'GET_PROJECT'
export const ADD_PROJECT = 'ADD_PROJECT'
export const CURRENT_PROJECT = 'CURRENT_PROJECT'
export const DELETE_PROJECT = 'DELETE_PROJECT'
export const ERROR_PROJECT = 'ERROR_PROJECT'
export const RESET = 'RESET'

export const TASKS_PROYECT = 'TASKS_PROYECT'
export const ADD_TASK = 'ADD_TASK'
export const DELETE_TASK = 'DELETE_TASK'
export const SELECT_TASK = 'SELECT_TASK'
export const UPTDATE_TASK = 'UPTDATE_TASK'
export const RESET_TASK = 'RESET_TASK'


export const SHOW_ALERT = 'SHOW_ALERT'
export const HIDE_ALERT = 'HIDE_ALERT'

export const REGISTER_SECCESS = 'REGISTER_SECCESS'
export const REGISTER_ERROR = 'REGISTER_ERROR'
export const GET_USER = 'GET_USER'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const CLOSE_SESSION = 'CLOSE_SESSION'

export const SET_LOADING = 'SET_LOADING'